import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
  return (
    <div className="bg-gradient-to-br from-brand-primary via-brand-secondary to-brand-conversion rounded-xl p-8 md:p-12 shadow-elevated">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="RocketLaunchIcon" size={32} className="text-white" />
        </div>

        <h2 className="text-3xl md:text-4xl font-headline font-bold text-white mb-4">
          Ready to Transform Your IT Infrastructure?
        </h2>
        
        <p className="text-lg font-body text-white/90 mb-8">
          Schedule a free consultation with our experts to discuss your specific needs and discover how we can help your business thrive.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Link
            href="/contact"
            className="w-full sm:w-auto flex items-center justify-center space-x-2 px-8 py-4 bg-white hover:bg-white/90 text-brand-primary rounded-lg font-cta font-semibold text-base shadow-card transition-all duration-300 transform hover:scale-105"
          >
            <Icon name="CalendarIcon" size={20} />
            <span>Schedule Free Assessment</span>
          </Link>

          <Link
            href="/contact"
            className="w-full sm:w-auto flex items-center justify-center space-x-2 px-8 py-4 bg-transparent border-2 border-white hover:bg-white/10 text-white rounded-lg font-cta font-semibold text-base transition-all duration-300"
          >
            <Icon name="PhoneIcon" size={20} />
            <span>Call: +966 55 2258277</span>
          </Link>
        </div>

        <div className="mt-8 flex items-center justify-center space-x-6 text-white/80">
          <div className="flex items-center space-x-2">
            <Icon name="CheckBadgeIcon" size={20} variant="solid" />
            <span className="text-sm font-body">No Obligation</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="ClockIcon" size={20} />
            <span className="text-sm font-body">30-Min Consultation</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="ShieldCheckIcon" size={20} />
            <span className="text-sm font-body">Confidential</span>
          </div>
        </div>
      </div>
    </div>
  );
}